<template>
    <focus-lock>
        <div
            role="dialog"
            aria-modal="true"
            :aria-label="$t('COSPLAY_PACK')"
            :style="{
                'font-family': customAttributes['fun-modal-font-family'],
                'background-image': `url('${modalBgImage}')`,
            }"
            :class="{ 'is-kiosk': isKiosk }"
            class="cz2__attach-pack-modal"
        >
            <div class="cz2__attach-pack-modal-content">
                <img
                    :src="customAttributes['fun-modal-logo-image']"
                    :alt="`${customAttributes['fun-style-clean']} Logo`"
                    class="cz2__attach-pack-modal-logo"
                >

                <div class="cz2__attach-pack-modal-pics">
                    <div
                        :aria-label="$t('YOUR_CUSTOM_POP')"
                        :style="{
                            'background-image': `url('${popSnapshot}')`,
                        }"
                        class="cz2__attach-pack-modal-snapshot cz2__full-height"
                    />

                    <p
                        :aria-label="$t('PLUS')"
                        class="plus"
                    >
                        &plus;
                    </p>

                    <div
                        :aria-label="customAttributes['fun-style-clean']"
                        class="cz2__attach-pack-modal-pack-wrapper cz2__full-height"
                    >
                        <div
                            :style="{
                                'background-image': `url('${customAttributes['fun-modal-costume-image']}')`,
                            }"
                            class="cz2__attach-pack-modal-pack cz2__full-width cz2__full-height"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        color: customAttributes['fun-modal-copy-font-color'],
                    }"
                >
                    <h1 class="cz2__attach-pack-modal-heading">
                        {{ customAttributes['fun-modal-heading'] }}
                    </h1>

                    <p class="cz2__attach-pack-modal-copy">
                        {{ customAttributes['fun-modal-copy'] }}
                    </p>

                    <p
                        v-if="canBuyPop"
                        :style="{
                            'font-family': customAttributes['fun-modal-price-font-family'],
                            'font-weight': customAttributes['fun-modal-price-font-weight'],
                        }"
                        class="cz2__attach-pack-modal-price"
                    >

                        {{ `${attachPackModalComponent.priceFormatted}` }} {{ $t('EACH') }}
                    </p>
                </div>

                <div class="cz2__attach-pack-modal-buttons">
                    <btn
                        :style="{
                            'font-family': customAttributes['fun-modal-cta-font-family'],
                            'font-weight': customAttributes['fun-modal-cta-font-weight'],
                            color: customAttributes['fun-modal-secondary-cta-font-color'],
                            background: customAttributes['fun-modal-secondary-cta-bg'],
                        }"
                        @click="closeModal"
                    >
                        {{ $t('NO_THANKS') }}
                    </btn>

                    <btn
                        :style="{
                            'font-family': customAttributes['fun-modal-cta-font-family'],
                            'font-weight': customAttributes['fun-modal-cta-font-weight'],
                            color: customAttributes['fun-modal-primary-cta-font-color'],
                            background: customAttributes['fun-modal-primary-cta-bg'],
                        }"
                        :disabled="!attachPackModalComponent.canAdd"
                        @click="addPack"
                    >
                        {{ $t('ADD_ATTACH_PACK') }}
                    </btn>
                </div>
            </div>
        </div>
    </focus-lock>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__attach-pack-modal {
            position: fixed;
            z-index: 99999;

            width: 100%;
            height: 100%;

            display: flex;
            justify-content: center;

            background-color: #EAEAEA;
            background-size: cover;
            background-repeat: no-repeat;

            // Special styles to handle extra divs added by focus-lock
            div:has([data-lock]) {
                width: 100%;
                height: 100%;
            }

            .cz2__attach-pack-modal-content {
                max-width: 1280px;
                height: 100%;
                padding: 8px;

                display: flex;
                flex-direction: column;
                align-items: center;

                text-align: center;
            }

            .cz2__attach-pack-modal-pics {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                flex: 1 1 0%;

                .cz2__attach-pack-modal-snapshot {
                    width: 40%;
                }

                .cz2__attach-pack-modal-snapshot,
                .cz2__attach-pack-modal-pack {
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .cz2__attach-pack-modal-pack-wrapper {
                    flex: 1 1 0%;

                    padding: 20px;
                }
            }

            .plus {
                font-family: 'Inter';
                font-size: 32px;
            }

            .cz2__attach-pack-modal-logo {
                width: auto;
                height: 81px;
            }

            .cz2__attach-pack-modal-heading {
                font-size: 48px;
            }

            .cz2__attach-pack-modal-copy {
                margin-bottom: 8px;

                letter-spacing: -0.93px;
            }

            .cz2__attach-pack-modal-copy,
            .cz2__attach-pack-modal-price {
                font-size: 15px;
            }

            .cz2__attach-pack-modal-price {
                margin-bottom: 40px;

                text-transform: uppercase;
            }

            .cz2__attach-pack-modal-buttons {
                display: flex;
                flex-direction: column-reverse;
                gap: 16px;

                button,
                button:hover {
                    font-size: 16px;
                }

                button {
                    min-width: 250px;
                    height: 48px;

                    &.cz2__btn--secondary {
                        background-color: white;
                    }
                }
            }

            @include respond-above(sm) {
                .cz2__attach-pack-modal-pics {
                    .cz2__attach-pack-modal-pack-wrapper {
                        padding: 30px;
                    }
                }
            }

            @include respond-above(lg) {
                flex-direction: row;

                .cz2__attach-pack-modal-content {
                    padding: 24px;
                }

                .cz2__attach-pack-modal-logo {
                    width: 362px;
                    height: 158px;
                }

                .cz2__attach-pack-modal-pics {
                    .cz2__attach-pack-modal-pack-wrapper {
                        padding: 40px;
                    }
                }

                .plus {
                    font-size: 80px;
                }

                .cz2__attach-pack-modal-copy,
                .cz2__attach-pack-modal-price {
                    font-size: 25px;
                }

                .cz2__attach-pack-modal-buttons {
                    flex-direction: row;

                    button,
                    button:hover,
                    button:focus {
                        font-size: 22px;
                    }
                }
            }

            &.is-kiosk {
                .cz2__attach-pack-modal-logo {
                    margin-bottom: 60px;

                    width: 452px;
                    height: 197px;
                }

                .plus {
                    position: absolute;
                    left: 45%;

                    font-size: 125px;
                }

                .cz2__attach-pack-modal-heading {
                    margin-bottom: 24px;
                }

                .cz2__attach-pack-modal-copy,
                .cz2__attach-pack-modal-price {
                    padding: 0 80px;

                    font-size: 25px;
                }

                .cz2__attach-pack-modal-buttons {
                    flex-direction: row;
                    gap: 24px;

                    button,
                    button:hover {
                        width: 319px;
                        font-size: 22px;

                        @include respond-above(sm) {
                            width: 410px;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import Btn from './ui/Btn.vue';

    export default {
        components: {
            FocusLock,
            Btn,
        },

        computed: {
            options() {
                return this.$store.state.customizer.options;
            },

            canBuyPop() {
                return this.options && this.options.canBuyPop;
            },

            attachPackModalComponent() {
                return this.$store.state.attachPackModalComponent;
            },

            customAttributes() {
                return this.attachPackModalComponent.component.custom;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            modalBgImage() {
                let bgImage = this.customAttributes['fun-modal-bg-d-image'];

                if (this.isMobile) {
                    bgImage = this.customAttributes['fun-modal-bg-m-image'];
                } else if (this.isKiosk) {
                    bgImage = this.customAttributes['fun-modal-bg-k-image'];
                }

                return bgImage;
            },

            popSnapshot() {
                return this.$store.state.customizer.attachPacksPreviewImage;
            },
        },

        mounted() {
            if (this.customAttributes['fun-modal-font']) {
                this.addFont(this.customAttributes['fun-modal-font']);
            }

            if (this.customAttributes['fun-modal-cta-font']) {
                this.addFont(this.customAttributes['fun-modal-cta-font']);
            }

            if (this.customAttributes['fun-modal-price-font']) {
                this.addFont(this.customAttributes['fun-modal-price-font']);
            }
        },

        methods: {
            closeModal() {
                this.$store.dispatch('setAttachPackModalComponent', null);
                this.$store.dispatch('showAttachPackModal', false);
            },

            addPack() {
                this.$store.dispatch('setAttachPackAddComponent', this.attachPackModalComponent);

                this.closeModal();
            },

            addFont(url) {
                const link = document.createElement('link');

                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = url;

                document.getElementsByTagName('HEAD')[0].appendChild(link);
            },
        },
    };
</script>
